import React from 'react';
import { Image } from '../../../../wag-react/next-components/image';
import StarIcon from '../../../../assets/icons/walker-profile/assets/star.svg';
import { BoxProps } from '../../../../wag-react/next-components/box';
import { Box } from '../../../../wag-react/core-components/box';
import { Typography } from '../../../../wag-react/components/Typography';
type Props = {
  averageRating: number;
  totalReviews: number;
  containerProps?: BoxProps;
};
export const WalkerRating = ({
  averageRating,
  totalReviews,
  containerProps = {}
}: Props) => <Box display="flex" {...containerProps} data-sentry-element="Box" data-sentry-component="WalkerRating" data-sentry-source-file="WalkerRating.tsx">
    <Box display="flex" alignItems="center" data-sentry-element="Box" data-sentry-source-file="WalkerRating.tsx">
      {Array.from(Array(Math.round(averageRating)).keys()).map(key => <Image key={key} src={StarIcon} alt="star" width="16px" height="16px" mr="4px" />)}
    </Box>
    <Typography color="#272727" px={1} variant="body2" fontSize="14px" data-sentry-element="Typography" data-sentry-source-file="WalkerRating.tsx">
      {averageRating}
    </Typography>
    <Typography color="#818181" variant="body2" fontSize="14px" data-sentry-element="Typography" data-sentry-source-file="WalkerRating.tsx">
      (
      {totalReviews}
      )
    </Typography>
  </Box>;